/**
 * @todo
 * Check why frontend can not import this particular enum
 * import {OrderOptionsValues as values} from '@bandido/shared/dtos';
 * into a jsx file
 */
export enum OrderOptionsValues {
  asc = 'ASC',
  desc = 'DESC',
}
